module.exports = __webpack_public_path__ + "images/c8ad98805d306ee10a9b2471dfc0698c.png";